var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Stack } from "@mui/material";
import React from "react";
import { Text } from "../../../Atoms";
import { nFormatter } from "../../../../helpers";
var OptionLabel = function (_a) {
    var color = _a.color, value = _a.value, label = _a.label, total = _a.total;
    return (_jsxs(Stack, __assign({ gap: 2, direction: "row", "data-testid": "option-".concat(label) }, { children: [_jsx(Box, { sx: {
                    width: 8,
                    height: 8,
                    bgcolor: color,
                    borderRadius: "2px",
                    mt: 1.5,
                } }), _jsxs(Box, { children: [_jsx(Text, __assign({ variant: "subtitle2", textTransform: "capitalize" }, { children: label })), _jsxs(Text, __assign({ variant: "body3" }, { children: [nFormatter(value), " (", "".concat(nFormatter((value / total) * 100), "%"), ")"] }))] })] })));
};
export default React.memo(OptionLabel);
